import database from "./database";
import dayJS from "dayjs";

let users = {
    namespaced: true,
    state: {
        mUsers: [],
        mUserProgress: [],
        mUserLog: [],
        mLevelProgressEvents: [],
    },
    mutations: {
        setUsers(state, values) {
            state.mUsers = values;
        },
        updateUsers(state, value) {
            // state.mUsers.forEach(v => {
            //     v.changed = false;
            // });
            // let index = state.mUsers.findIndex(v => {
            //     return v.uid === value.uid;
            // });
            // if (index >= 0) {
            //     state.mUsers.splice(index, 1, value);
            // } else {
            //     state.mUsers.push(value);
            // }
        },
        setUserProgress(state, values) {
            state.mUserProgress = values;
        },
        addUserProgress(state, values) {
            for(let i = 0; i < state.mUserProgress.length; ++i){
                state.mUserProgress[i] += values;
            }
            state.mUserProgress.push(values);
        },
        setUserLog(state, values) {
            state.mUserLog = values;
        },
        addUserLog(state, value) {
           if(value.collection == "level_events") {
               let eventType = "level";
               value.querySnapshot.forEach((doc) => {
                   let data = doc.data()
                   let dataString = ""
                   dataString += data.game ? `'game':${data.game}` : ''
                   dataString += data.event ? `\t'event':${data.event}` : ''
                   dataString += data.level ? `\t'level':${data.level}` : ''
                   dataString += data.difficulty ?  `\t'difficulty':${data.difficulty}` : ''
                   dataString += data.time ? `\t'time':${data.time}` : ''
                   dataString += data.version ? `\t'version':${data.version}`: ''
                   state.mUserLog.push({
                       eventType: eventType,
                       data: dataString,
                       created: data.created ? dayJS(data.created.toDate()).format('DD/MM/YYYY HH:mm:ss') : '',
                       timestamp: data.created.seconds
                   })
               });
           }
           else if(value.collection == "game_item_events") {
               let eventType = "game item";
               value.querySnapshot.forEach((doc) => {
                   let data = doc.data()
                   let dataString = ""
                   dataString += data.event ? `'event':${data.event}` : ''
                   dataString += data.item ? `\t'item':${data.item}` : ''
                   dataString += data.value ? `\t'value':${data.value}` : ''
                   dataString += data.game ?  `\t'game':${data.game}` : ''
                   dataString += data.level ? `\t'level':${data.level}` : ''
                   dataString += data.difficulty ? `\t'difficulty':${data.difficulty}`: ''
                   dataString += data.time ? `\t'time':${data.time}`: ''
                   dataString += data.location ? `\t'location':${data.location}`: ''
                   dataString += data.source ? `\t'source':${data.source}`: ''
                   dataString += data.version ? `\t'version':${data.version}`: ''
                   state.mUserLog.push({
                       eventType: eventType,
                       data: dataString,
                       created: data.created ? dayJS(data.created.toDate()).format('DD/MM/YYYY HH:mm:ss') : '',
                       timestamp: data.created.seconds
                   })
               });
           }else if(value.collection == "shop_item_events") {
               let eventType = "shop item";
               value.querySnapshot.forEach((doc) => {
                   let data = doc.data()
                   let dataString = ""
                   dataString += data.item ? `item:${data.item}` : ''
                   dataString += data.price ? `\t'price':${data.price}` : ''
                   dataString += data.currency ? `\t'currency':${data.currency}` : ''
                   dataString += data.location ? `\t'location':${data.location}` : ''
                   dataString += data.version ? `\t'version':${data.version}` : ''
                   state.mUserLog.push({
                       eventType: eventType,
                       data: dataString,
                       created: data.created ? dayJS(data.created.toDate()).format('DD/MM/YYYY HH:mm:ss') : '',
                       timestamp: data.created.seconds
                   })
               });
           }
        },
        setLevelProgressEvents(state, values) {
            state.mLevelProgressEvents = values;
        },
        addLevelProgressEvent(state, payload) {
            let levelItem = state.mLevelProgressEvents.find(value => value.level === payload.level);
            if(!levelItem){
                levelItem = { level: payload.level, start: 0, complete: 0, fail: 0, quit: 0, count: 0}
                state.mLevelProgressEvents.push(levelItem);
            }
            
            if(payload.event === 'start'){
                levelItem.start = payload.count
            }
            else if(payload.event === 'complete'){
                levelItem.complete = payload.count
            }
            else if(payload.event === 'fail'){
                levelItem.fail = payload.count
            }
            else if(payload.event === 'quit'){
                levelItem.quit = payload.count
            }
            levelItem.count = levelItem.start + levelItem.complete + levelItem.fail + levelItem.quit;
            //console.log("addLevelProgressEvent level: " + payload.level + " event: " + payload.event);
        }
    },
    getters: {
        getUsers: state => {
            return state.mUsers;
        },
        getUserProgress: state => {
            return state.mUserProgress;
        },
        getUserProgressSum: state => {
            let sum = 0;
            state.mUserProgress.forEach((val) => {
                sum += val
            })
            return sum;
        },
        getUserLog: state => {
            return state.mUserLog;
        },
        getLevelProgressEvent: state => {
            return state.mLevelProgressEvents;
        },
    },
    actions: {
        loadUsers({ /*dispatch,*/ commit}) {
            // return Promise.all([
            //     database
            //         .database()
            //         .ref(DB_ROOT_PATH + "/curr")
            //         .once("value", function (snapshot) {
            //             let data = Object.values(snapshot.val() || {});
            //             let values = data.map(v => deserialize(Currency..., v));
            //             commit("set...", values);
            //         }),
            //     database
            //         .database()
            //         .ref(DB_ROOT_PATH + "/rew")
            //         .once("value", function (snapshot) {
            //             let data = Object.values(snapshot.val() || {});
            //             let values = data.map(v => deserialize(Reward..., v));
            //             commit("set...", values);
            //         }),
            // ]).then(() => {
            //     //dispatch("push...");
            // })
        },
        loadUserProgress({ /*dispatch,*/ commit}, payload) {
            commit('setLoading', true, {root: true});
            commit("setUserProgress", []);

            let levelCallbacks = [];
            for (let i = payload.start; i <= payload.end; ++i){
                let collection = database.collection("users")
                collection = collection.where("level", "==", i)
                if(payload.platform) collection = collection.where("platform", "==", payload.platform.toLowerCase())
                if(payload.version) collection = collection.where("version", "==", payload.version)
                levelCallbacks.push(collection.get().
                    then((querySnapshot) => {
                        //console.log("Vuex.Store users levelCallback " + i)
                        commit("addUserProgress", querySnapshot.docs.length);
                    }).catch((error) => {
                        console.log(error)
                    })
                )
            }
            return Promise.all(levelCallbacks).then(() => {
                // dispatch("push...");
                commit("setLoading", false, {root: true});
            })
        },
        loadUserLog({ /*dispatch,*/ commit}, payload) {
            commit('setLoading', true, {root: true});
            commit("setUserLog", []);

            let eventCallbacks = [];

            let levelEventCollection = database.collection("level_events").where("user_id", "==", payload.userId)
            eventCallbacks.push(
                levelEventCollection.get().then((querySnapshot) => {
                    commit("addUserLog", {collection: "level_events", querySnapshot : querySnapshot});
                }).catch((error) => {
                    console.log(error)
                })
            )

            let gameItemEventCollection = database.collection("game_item_events").where("user_id", "==", payload.userId)
            eventCallbacks.push(
                gameItemEventCollection.get().then((querySnapshot) => {
                    commit("addUserLog", {collection: "game_item_events", querySnapshot : querySnapshot});
                }).catch((error) => {
                    console.log(error)
                })
            )

            let shopItemEventCollection = database.collection("shop_item_events").where("user_id", "==", payload.userId)
            eventCallbacks.push(
                shopItemEventCollection.get().then((querySnapshot) => {
                    commit("addUserLog", {collection: "shop_item_events", querySnapshot : querySnapshot});
                }).catch((error) => {
                    console.log(error)
                })
            )

            return Promise.all(eventCallbacks).then(() => {
                // dispatch("push...");
                commit("setLoading", false, {root: true});
            })
        },
        loadLevelProgressEvents({ /*dispatch,*/ commit}, payload) {
            commit('setLoading', true, {root: true});
            commit("setLevelProgressEvents", []);
            //console.log("loadLevelProgressEvents")
            
            let levelEvents = ['start', 'complete', 'fail', 'quit'];
            let levelCallbacks = [];
            levelEvents.forEach((levelEvent) => {
                for (let i = payload.start; i <= payload.end; ++i){
                    //console.log("forEach: level: " + i + "event" + levelEvent)
                    let collection = database.collection("level_events")
                    collection = collection.where("level", "==", i)
                    collection = collection.where("event", "==", levelEvent)
                    if(payload.version) collection = collection.where("version", "==", payload.version)
                    if(payload.game) collection = collection.where("game", "==", payload.game)
                    levelCallbacks.push(collection.get().
                        then((querySnapshot) => {
                            let lenght = querySnapshot.docs.length;
                            //console.log("querySnapshot: " + lenght.toString())
                            if( lenght > 0){
                                commit("addLevelProgressEvent", { level: querySnapshot.docs[0].data().level, 
                                                                  event: querySnapshot.docs[0].data().event, 
                                                                  count: lenght});
                            }
                        }).catch((error) => {
                            console.log(error)
                        })
                    )
                }
            })
            
            return Promise.all(levelCallbacks).then(() => {
                // dispatch("push...");
                commit("setLoading", false, {root: true});
            })
        },
        // clear({commit}) {
        //     commit("set...", []);
        //     return Promise.resolve();
        // },
    }
}

export default users;
